export default{
	people:[
		":smile:",
		":laughing:",
		":blush:",
		":smiley:",
		":relaxed:",
		":smirk:",
		":heart_eyes:",
		":kissing_heart:",
		":kissing_closed_eyes:",
		":flushed:",
		":relieved:",
		":grin:",
		":wink:",
		":stuck_out_tongue_winking_eye:",
		":stuck_out_tongue_closed_eyes:",
		":grinning:",
		":kissing:",
		":kissing_smiling_eyes:",
		":stuck_out_tongue:",
		":sleeping:",
		":worried:",
		":frowning:",
		":anguished:",
		":open_mouth:",
		":grimacing:",
		":confused:",
		":hushed:",
		":expressionless:",
		":unamused:",
		":sweat_smile:",
		":sweat:",
		":disappointed_relieved:",
		":weary:",
		":confounded:",
		":cold_sweat:",
		":persevere:",
		":cry:",
		":sob:",
		":joy:",
		":astonished:",
		":scream:",
		":tired_face:",
		":angry:",
		":rage:",
		":triumph:",
		":sleepy:",
		":yum:",
		":mask:",
		":sunglasses:",
		":dizzy_face:",
		":imp:",
		":neutral_face:",
		":no_mouth:",
		":innocent:",
		":heart:",
		":broken_heart:",
		":heartbeat:",
		":heartpulse:",
		":two_hearts:",
		":revolving_hearts:",
		":cupid:",
		":sparkling_heart:",
		":sparkles:",
		":dizzy:",
		":exclamation:",
		":question:",
		":zzz:",
		":dash:",
		":sweat_drops:",
		":notes:",
		":musical_note:",
		":fire:",
		":+1:",
		":-1:",
		":ok_hand:",
		":fist_raised:",
		":v:",
		":wave:",
		":hand:",
		":open_hands:",
		":point_up:",
		":point_down:",
		":point_left:",
		":point_right:",
		":raised_hands:",
		":pray:",
		":point_up_2:",
		":clap:",
		":muscle:",
		":running_man:",
		":couple:",
		":family_man_woman_boy:",
		":couple_with_heart_woman_man:",
		":smiley_cat:",
		":smile_cat:",
		":heart_eyes_cat:",
		":kissing_cat:",
		":smirk_cat:",
		":scream_cat:",
		":crying_cat_face:",
		":joy_cat:",
		":pouting_cat:",
		":see_no_evil:",
		":hear_no_evil:",
		":speak_no_evil:",
		":feet:",
		":lips:",
		":kiss:",
	],
	nature:[
		":sunny:",
		":umbrella:",
		":cloud:",
		":snowflake:",
		":snowman:",
		":zap:",
		":cyclone:",
		":foggy:",
		":ocean:",
		":sun_with_face:",
		":cat:",
		":dog:",
		":mouse:",
		":hamster:",
		":rabbit:",
		":wolf:",
		":frog:",
		":tiger:",
		":koala:",
		":bear:",
		":pig:",
		":pig_nose:",
		":cow:",
		":boar:",
		":monkey_face:",
		":monkey:",
		":horse:",
		":racehorse:",
		":camel:",
		":sheep:",
		":elephant:",
		":panda_face:",
		":snake:",
		":bird:",
		":baby_chick:",
		":hatching_chick:",
		":chicken:",
		":penguin:",
		":turtle:",
		":bug:",
		":bee:",
		":ant:",
		":beetle:",
		":snail:",
		":octopus:",
		":tropical_fish:",
		":fish:",
		":whale:",
		":whale2:",
		":dolphin:",
		":cow2:",
		":ram:",
		":rat:",
		":water_buffalo:",
		":tiger2:",
		":dragon:",
		":goat:",
		":rooster:",
		":ox:",
		":dragon_face:",
		":blowfish:"
	],
	object: [
		":bamboo:",
		":gift_heart:",
		":dolls:",
		":school_satchel:",
		":mortar_board:",
		":flags:",
		":fireworks:",
		":wind_chime:",
		":rice_scene:",
		":ghost:",
		":christmas_tree:",
		":gift:",
		":bell:",
		":no_bell:",
		":tada:",
		":confetti_ball:",
		":balloon:",
		":crystal_ball:",
		":cd:",
		":dvd:",
		":floppy_disk:",
		":camera:",
		":video_camera:",
		":movie_camera:",
		":computer:",
		":tv:",
		":iphone:",
		":phone:",
		":telephone_receiver:",
		":pager:",
		":fax:",
		":minidisc:",
		":vhs:",
		":sound:",
		":speaker:",
		":mute:",
		":loudspeaker:",
		":hourglass_flowing_sand:",
		":alarm_clock:",
		":watch:",
		":radio:",
		":satellite:",
		":loop:",
		":mag:",
		":mag_right:",
		":unlock:",
		":lock:",
		":lock_with_ink_pen:",
		":closed_lock_with_key:",
		":key:",
		":bulb:",
		":flashlight:",
		":high_brightness:",
		":low_brightness:",
		":electric_plug:",
		":battery:",
		":calling:",
		":email:",
		":mailbox:",
		":postbox:",
		":bath:",
		":bathtub:",
		":shower:",
		":toilet:",
		":wrench:",
		":nut_and_bolt:",
		":hammer:",
		":seat:",
		":moneybag:",
		":yen:",
		":dollar:",
		":pound:",
		":euro:",
		":credit_card:",
		":money_with_wings:",
		":inbox_tray:",
		":outbox_tray:",
		":incoming_envelope:",
		":postal_horn:",
		":mailbox_closed:",
		":mailbox_with_mail:",
		":door:",
		":smoking:",
		":bomb:",
		":gun:",
		":hocho:",
		":pill:",
		":syringe:",
		":page_facing_up:",
		":page_with_curl:",
		":bookmark_tabs:",
		":bar_chart:",
		":chart_with_upwards_trend:",
		":chart_with_downwards_trend:",
		":scroll:",
		":scroll:",
		":clipboard:",
		":calendar:",
		":card_index:",
		":file_folder:",
		":open_file_folder:",
		":scissors:",
		":pushpin:",
		":paperclip:",
		":black_nib:",
		":pencil2:",
		":straight_ruler:",
		":triangular_ruler:",
		":closed_book:",
		":green_book:",
		":blue_book:",
		":orange_book:",
		":notebook:",
		":notebook_with_decorative_cover:",
		":ledger:",
		":books:",
		":bookmark:",
		":name_badge:",
		":microscope:",
		":telescope:",
		":newspaper:",
		":football:",
		":basketball:",
		":soccer:",
		":baseball:",
		":tennis:",
		":8ball:",
		":rugby_football:",
		":bowling:",
		":golf:",
		":mountain_biking_man:",
		":biking_man:",
		":horse_racing:",
		":snowboarder:",
		":swimming_man:",
		":surfing_man:",
		":ski:",
		":spades:",
		":hearts:",
		":clubs:",
		":diamonds:",
		":gem:",
		":ring:",
		":trophy:",
		":musical_score:",
		":violin:",
		":space_invader:",
		":video_game:",
		":black_joker:",
		":flower_playing_cards:",
		":game_die:",
		":dart:",
		":clapper:",
		":memo:",
		":art:",
		":microphone:",
		":headphones:",
		":trumpet:",
		":saxophone:",
		":guitar:",
		":mans_shoe:",
		":sandal:",
		":high_heel:",
		":lipstick:",
		":boot:",
		":shirt:",
		":necktie:",
		":womans_clothes:",
		":dress:",
		":running_shirt_with_sash:",
		":jeans:",
		":bikini:",
		":bikini:",
		":ribbon:",
		":tophat:",
		":crown:",
		":womans_hat:",
		":briefcase:",
		":handbag:",
		":pouch:",
		":purse:",
		":eyeglasses:",
		":fishing_pole_and_fish:",
		":coffee:",
		":tea:",
		":sake:",
		":baby_bottle:",
		":beer:",
		":dango:",
		":birthday:",
		":cookie:",
		":candy:",
		":lollipop:"
	],
	place: [
		":house:",
		":house_with_garden:",
		":school:",
		":office:",
		":post_office:",
		":hospital:",
		":bank:",
		":convenience_store:",
		":love_hotel:",
		":hotel:",
		":wedding:",
		":church:",
		":department_store:",
		":european_post_office:",
		":city_sunrise:",
		":city_sunset:",
		":japanese_castle:",
		":european_castle:",
		":tent:",
		":factory:",
		":tokyo_tower:",
		":japan:",
		":mount_fuji:",
		":sunrise_over_mountains:",
		":sunrise:",
		":stars:",
		":statue_of_liberty:",
		":bridge_at_night:",
		":carousel_horse:",
		":rainbow:",
		":ferris_wheel:",
		":fountain:",
		":roller_coaster:",
		":ship:",
		":speedboat:",
		":boat:",
		":rowing_man:",
		":anchor:",
		":rocket:",
		":airplane:",
		":helicopter:",
		":steam_locomotive:",
		":tram:",
		":mountain_railway:",
		":bike:",
		":aerial_tramway:",
		":suspension_railway:",
		":mountain_cableway:",
		":tractor:",
		":blue_car:",
		":oncoming_automobile:",
		":car:",
		":taxi:",
		":oncoming_taxi:",
		":articulated_lorry:",
		":bus:",
		":oncoming_bus:",
		":rotating_light:",
		":police_car:",
		":oncoming_police_car:",
		":fire_engine:",
		":ambulance:",
		":minibus:",
		":truck:",
		":train:",
		":station:",
		":train2:",
		":bullettrain_front:",
		":bullettrain_side:",
		":light_rail:",
		":monorail:",
		":railway_car:",
		":trolleybus:",
		":ticket:",
		":fuelpump:",
		":vertical_traffic_light:",
		":traffic_light:",
		":warning:",
		":construction:",
		":beginner:",
		":atm:",
		":slot_machine:",
		":busstop:",
		":barber:",
		":hotsprings:",
		":checkered_flag:",
		":crossed_flags:",
		":performing_arts:",
		":round_pushpin:",
		":triangular_flag_on_post:",
		":jp:",
		":kr:",
		":cn:",
		":us:",
		":fr:",
		":es:",
		":it:",
		":ru:",
		":gb:",
		":de:"
	],
	symbol: [
		":1234:",
		":symbols:",
		":arrow_backward:",
		":arrow_down:",
		":arrow_forward:",
		":arrow_left:",
		":abcd:",
		":vs:",
		":chart:",
		":link:",
		":heart_decoration:",
		":vibration_mode:",
		":100:"
	]
}


// WEBPACK FOOTER //
// ./src/emoji.js